import { optionalStringParam, parseableSearchSchema } from "@crm/effect/schema/search";
import { Schema } from "effect";

export const inviteSearchSchema = parseableSearchSchema(
  Schema.Struct({
    from: optionalStringParam(),
  }),
);

export type InviteSearch = Schema.Schema.Type<typeof inviteSearchSchema>;
